"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const StorefrontRedirect = (() => {
    const CONFIG_KEY = 'redirectConfig';
    const BYPASS_COOKIE = 'storefront_redirect_bypass';
    const BYPASS_PARAM = 'no_redirect';
    const COOKIE_DAYS = 360;
    function getCookie(name) {
        var _a;
        return (_a = document.cookie
            .split('; ')
            .find((row) => row.startsWith(`${name}=`))) === null || _a === void 0 ? void 0 : _a.split('=')[1];
    }
    function setCookie(name, value, days) {
        const maxAge = days * 24 * 60 * 60;
        document.cookie = `${name}=${value}; path=/; max-age=${maxAge}; SameSite=Lax`;
    }
    function deleteCookie(name) {
        document.cookie = `${name}=; path=/; max-age=0; SameSite=Lax`;
    }
    function handleBypassParam() {
        const params = new URLSearchParams(window.location.search);
        const value = params.get(BYPASS_PARAM);
        if (value === 'true') {
            setCookie(BYPASS_COOKIE, 'true', COOKIE_DAYS);
            return true;
        }
        if (value === 'false') {
            deleteCookie(BYPASS_COOKIE);
            return false;
        }
        return getCookie(BYPASS_COOKIE) === 'true';
    }
    function getTargetStorefront(config, countryCode) {
        const targetStorefront = config.countryToStorefront[countryCode];
        return config.storefronts[targetStorefront] || config.storefronts.US;
    }
    function normalizeHost(host) {
        return host
            .replace(/^https?:\/\//, '')
            .replace(/^www\./, '')
            .split('/')[0]
            .toLowerCase();
    }
    function getDetectedCountryCode() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            try {
                const response = yield fetch('/browsing_context_suggestions.json');
                const data = yield response.json();
                return (_b = (_a = data === null || data === void 0 ? void 0 : data.detected_values) === null || _a === void 0 ? void 0 : _a.country) === null || _b === void 0 ? void 0 : _b.handle;
            }
            catch (error) {
                console.error('Geo detection failed', error);
                return null;
            }
        });
    }
    function run() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const config = window[CONFIG_KEY];
            if (!config)
                return;
            if ((_a = window.Shopify) === null || _a === void 0 ? void 0 : _a.designMode)
                return;
            if (handleBypassParam())
                return;
            const detectedCountryCode = yield getDetectedCountryCode();
            if (!detectedCountryCode)
                return;
            const currentStorefront = window.location.hostname;
            const targetStorefront = getTargetStorefront(config, detectedCountryCode);
            const normalizedCurrentStorefront = normalizeHost(currentStorefront);
            const normalizedTargetStorefronts = targetStorefront.map(normalizeHost);
            if (!currentStorefront || !targetStorefront)
                return;
            if (normalizedTargetStorefronts.includes(normalizedCurrentStorefront))
                return;
            window.location.replace(targetStorefront[0]);
        });
    }
    return { run };
})();
document.addEventListener('DOMContentLoaded', StorefrontRedirect.run);
